import { GarageType } from '../domain/types/garageType';

export const garageTypeLabels: Record<GarageType, string> = {
  BOX: 'Box',
  POSTO_AUTO: 'Posto auto',
  RIMESSA: 'Rimessa',
};
